import { ReferenceField, useRecordContext } from "react-admin";
import { declassifyResource } from "~/helpers";

export const PolymorphicReferenceField = ({ reference_source, ...props }) => {
  const record = useRecordContext();
  const reference = declassifyResource(record[reference_source]);
  return <ReferenceField {...props} reference={reference} />;
};
